import styled from 'styled-components'
import { belowTablet } from 'utilities/styled'
import { Columns } from 'components/flex'

export const HeadingColumns = styled(Columns)`
    align-items: center;

    margin-bottom: 16px;

    ${belowTablet`
        row-gap: 16px;
    `}
`